// Rozpoznanie przeglądarki — wyłącznie po to, żeby przy zablokowanych powiadomieniach
// wskazać WŁAŚCIWĄ instrukcję. Ścieżka odblokowania jest w każdej przeglądarce inna,
// a ogólne „sprawdź ustawienia" nikomu nie pomaga.

export type BrowserId = 'chrome' | 'edge' | 'safari' | 'firefox' | 'opera' | 'other';

export interface BrowserInfo {
  id: BrowserId;
  name: string;
  /** Oficjalna dokumentacja producenta o powiadomieniach witryn. */
  notificationsHelpUrl?: string;
}

const HELP: Record<Exclude<BrowserId, 'other'>, { name: string; url: string }> = {
  chrome: {
    name: 'Chrome',
    url: 'https://support.google.com/chrome/answer/3220216',
  },
  edge: {
    name: 'Edge',
    url: 'https://support.microsoft.com/pl-pl/microsoft-edge/zarz%C4%85dzanie-powiadomieniami-witryn-internetowych-w-przegl%C4%85darce-microsoft-edge-0c586171-03fe-1cf7-bc4c-5ea1b3ed5dc7',
  },
  safari: {
    name: 'Safari',
    url: 'https://support.apple.com/pl-pl/guide/safari/sfri40734/mac',
  },
  firefox: {
    name: 'Firefox',
    url: 'https://support.mozilla.org/pl/kb/powiadomienia-web-push-firefox',
  },
  opera: {
    name: 'Opera',
    url: 'https://help.opera.com/en/latest/web-preferences/#notifications',
  },
};

/**
 * Kolejność testów ma znaczenie: Edge i Opera podają się w `userAgent` również za
 * Chrome, a Chrome za Safari. Pierwsze dopasowanie wygrywa, więc pochodne Chromium
 * muszą być sprawdzane przed samym Chrome.
 */
export const detectBrowser = (): BrowserInfo => {
  if (typeof navigator === 'undefined') return { id: 'other', name: '' };

  const ua = navigator.userAgent || '';
  const brands = (navigator as { userAgentData?: { brands?: Array<{ brand: string }> } })
    .userAgentData?.brands?.map((entry) => entry.brand.toLowerCase()) || [];

  const has = (needle: string) => ua.includes(needle) || brands.some((brand) => brand.includes(needle.toLowerCase()));

  let id: BrowserId = 'other';
  if (has('Edg')) id = 'edge';
  else if (has('OPR') || has('Opera')) id = 'opera';
  else if (has('Firefox') || has('FxiOS')) id = 'firefox';
  else if (has('Chrome') || has('CriOS') || has('Chromium')) id = 'chrome';
  else if (has('Safari')) id = 'safari';

  if (id === 'other') return { id, name: '' };

  const entry = HELP[id];
  return { id, name: entry.name, notificationsHelpUrl: entry.url };
};
